module.exports = __webpack_public_path__ + "static/media/Ruleta.733c22c4.svg";